import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getRegionRBCultureCatalog = state => state.models[name].data.rb;
export const getRegionNormCultureCatalog = state => state.models[name].data.norm;
export const getCurRegionCulture = state => state.models[name].item;